import { useMutation } from '@tanstack/react-query';
import { nominatePrefect, removePrefect } from 'api/classroomApi';
import { queryClient } from 'App';
import LoadingButton from 'components/fantaclasse/LoadingButton';
import PropTypes from 'prop-types';
import React from 'react';
import { Button, Modal } from 'react-bootstrap';
import { toast } from 'react-toastify';

const PrefectActionModal = ({ prefectUser, setPrefectUser, setShowModal }) => {
  const nominatePrefectMutation = useMutation({
    mutationFn: nominatePrefect,
    onSuccess: data => {
      prefectUser.prefect = true;
      queryClient.invalidateQueries({ queryKey: ['classroomUsers'] });
      toast.success(() => (
        <span>
          <strong>{data.username}</strong> è stato nominato capoclasse!
        </span>
      ));
    },
    onError: err => {
      prefectUser.prefect = false;
      toast.error(err.response?.data?.message || err.message);
    },
    onSettled: () => {
      handleCloseModal();
    }
  });

  const removePrefectMutation = useMutation({
    mutationFn: removePrefect,
    onSuccess: data => {
      prefectUser.prefect = false;
      queryClient.invalidateQueries({ queryKey: ['classroomUsers'] });
      toast.success(() => (
        <span>
          <strong>{data.username}</strong> non è più capoclasse!
        </span>
      ));
    },
    onError: err => {
      prefectUser.prefect = true;
      toast.error(err.response?.data?.message || err.message);
    },
    onSettled: () => {
      handleCloseModal();
    }
  });

  const handlePrefectAction = async () => {
    if (prefectUser.prefect) {
      removePrefectMutation.mutate(prefectUser?.username);
    } else {
      nominatePrefectMutation.mutate(prefectUser?.username);
    }
  };

  const handleCloseModal = () => {
    setPrefectUser(null);
    setShowModal(true);
  };

  return (
    <Modal
      show={prefectUser !== null}
      onHide={handleCloseModal}
      size="lg"
      centered
    >
      <Modal.Header className="p-4">
        <Modal.Title id="contained-modal-title-vcenter">
          {prefectUser?.prefect
            ? `Vuoi rimuovere ${prefectUser?.username} dai CapoClasse?`
            : `Vuoi nominare ${prefectUser?.username} come CapoClasse?`}
        </Modal.Title>
      </Modal.Header>
      <Modal.Body>
        {prefectUser?.prefect
          ? `Rimuovendo ${prefectUser?.username} dai CapoClasse, non potrà più: `
          : `I CapoClasse possono: `}
        <ul className="mb-0">
          <li>
            Aggiungere <strong>BONUS o MALUS</strong> a docenti e studenti
          </li>
          <li>
            <strong>Nominare</strong> altri Capoclasse
          </li>
          <li>
            <strong>Rimuovere</strong> gli altri Capoclasse
          </li>
          <li>
            <strong>Modificare</strong> docenti, studenti e informazioni della
            classe
          </li>
        </ul>
      </Modal.Body>
      <Modal.Footer>
        <Button variant="secondary" onClick={handleCloseModal}>
          Indietro
        </Button>
        <LoadingButton
          text="Conferma"
          variant={prefectUser?.prefect ? 'danger' : 'primary'}
          isLoading={
            nominatePrefectMutation.isPending || removePrefectMutation.isPending
          }
          action={handlePrefectAction}
        />
      </Modal.Footer>
    </Modal>
  );
};

PrefectActionModal.propTypes = {
  prefectUser: PropTypes.shape({
    username: PropTypes.string.isRequired,
    prefect: PropTypes.bool.isRequired
  }),
  setPrefectUser: PropTypes.func.isRequired,
  setShowModal: PropTypes.func.isRequired
};

export default PrefectActionModal;
